import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { updateSearchField } from "../../Redux/Reducers/searchSlice";
import { BoroCodeSelect } from "../../utils/boros/BoroCodeSelect";
import Bookmarks from "./Bookmarks";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { auth0Config } from "../../Config/auth0Conifg";
import { disclaimerSearch1 } from "../Tos/Disclaimer";

export default function Search() {
  const navigate = useNavigate();
  const search = useAppSelector((state) => state.search.params);
  const { getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    dispatch(
      updateSearchField({ field: e.target.name, value: e.target.value }),
    );
  };
  const submitClick = () => {
    if (
      search.boro === "" ||
      search.houseNo === "" ||
      search.streetName === ""
    ) {
      const errors: string[] = [];
      if (search.boro === "") errors.push("Borough is required");
      if (search.houseNo === "") errors.push("House Number is required");
      if (search.streetName === "") errors.push("Street Name is required");
      alert(errors.join("\n"));
      return null;
    }
    navigate("/property-search/candidates");
  };
  useEffect(() => {
    getAccessTokenSilently({
      authorizationParams: {
        audience: auth0Config.audience,
      },
    }).then((accessToken) => {
      setToken(accessToken);
    });
  }, []);
  return (
    <div className="search">
      <div className="search-with-disclaimer">
        <div className="search-content">
          <div className="input">
            <BoroCodeSelect
              name="boro"
              value={search.boro}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div className="input">
            <input
              type="text"
              name="houseNo"
              value={search.houseNo}
              onChange={(e) => handleChange(e)}
              placeholder="House Number"
            />
          </div>
          <div className="input">
            <input
              type="text"
              name="streetName"
              value={search.streetName}
              onChange={(e) => handleChange(e)}
              placeholder="Street Name"
            />
          </div>
          <div className="input">
            <input
              type="text"
              name="aptNo"
              value={search.aptNo}
              onChange={(e) => handleChange(e)}
              placeholder="Apt Number"
            />
          </div>
          <div className="input">
            <button onClick={() => submitClick()}>Search</button>
          </div>
        </div>
        <div className="disclaimer">{disclaimerSearch1}</div>
      </div>
      {token && (
        <div>
          <h2>History</h2>
          <Bookmarks token={token} />
        </div>
      )}
    </div>
  );
}
